
import { Options, Vue } from 'vue-class-component';
import wordService from '@/a1/word/word-service';
import utilService from '@/services/util-service';
import { GetWordStatsResponse } from '@/a1/word/word-model';
import { DateFormatType } from '@/models/date-format-type.model';
import store from '@/store';
import storeService from '@/services/store-service';
import userService from '@/a1/user/user-service';

@Options({
  components: {
  },
})
export default class HomeView extends Vue {
  stats: GetWordStatsResponse | null = null;

  async mounted() {
    if (!store.getters.isAuthenticated)
      return;

    this.stats = await wordService.getStats();
  }


  get username() {
    return store.getters.username;
  }

  async logout() {
    if (!confirm(`Are you sure to logout?`))
      return;

    storeService.clearUser();
    await userService.logout();
    this.goToRoute('login');
  }

  goToRoute(routeName: string) {
    this.$router.push({ name: routeName });
  }

  toFixedLen(date?: string) {
    return utilService.toFormattedDateTime(date, DateFormatType.Second);
  }

  toFormattedString(num: number) {
    return utilService.toFormattedNumString(num);
  }
}
